// Module
var code = "<react-component name=\"SequencesList\"></react-component>\n";
// Exports
module.exports = code;